// "계약 관리" 메뉴(프로젝트 관리 + 유지보수 관리 통합, 2026-10-20 ksm_frontend feat/contract-menu
// 포팅)의 유형 필터 순수 로직. localStorage 접근은 pushLink.js와 같은 관례로 storage를 인자로
// 받아 분리한다(전역 localStorage를 직접 참조하지 않으면 테스트에서 모킹 없이 그냥 fake storage를
// 넘길 수 있다).

// 백엔드(ForecastSearchDto.prjTyp, PMS_CST_INF.PRJ_TYP)가 쓰는 코드값.
// ''(빈값)이면 백엔드 쿼리가 PRJ_TYP 조건을 안 걸어서 전체가 나온다(ForcastMapper.xml 참고).
export const CONTRACT_TYPE_ALL = '';
export const CONTRACT_TYPE_PROJECT = 'N';
export const CONTRACT_TYPE_MAINT = 'M';

const VALID_TYPES = [CONTRACT_TYPE_ALL, CONTRACT_TYPE_PROJECT, CONTRACT_TYPE_MAINT];

// 유형 칩 표시 - components/projectmng/info/ProjectStatusList.js(같은 화면의 상태 칩)와
// 같은 칩 스타일/라벨을 쓴다.
export const CONTRACT_TYPE_OPTIONS = [
  { value: CONTRACT_TYPE_ALL, label: '전체', color: 'warning' },
  { value: CONTRACT_TYPE_PROJECT, label: '프로젝트', color: 'info' },
  { value: CONTRACT_TYPE_MAINT, label: '유지보수', color: 'success' },
];

export const CONTRACT_TYPE_STORAGE_KEY = 'bito.contractmng.prjTyp';

export function isValidContractType(value) {
  return VALID_TYPES.includes(value);
}

// 마지막으로 고른 유형을 기억한다. 못 읽으면(프라이빗 모드 등) 전체로 돌아간다.
export function readStoredContractType(storage) {
  if (!storage) return CONTRACT_TYPE_ALL;
  try {
    const stored = storage.getItem(CONTRACT_TYPE_STORAGE_KEY);
    return isValidContractType(stored) ? stored : CONTRACT_TYPE_ALL;
  } catch (e) {
    return CONTRACT_TYPE_ALL;
  }
}

export function writeStoredContractType(storage, value) {
  if (!storage || !isValidContractType(value)) return;
  try {
    storage.setItem(CONTRACT_TYPE_STORAGE_KEY, value);
  } catch (e) {
    // 프라이빗 모드/용량 초과 등은 무시 - "기억하면 편한" 정도라 화면 동작엔 지장이 없어야 한다.
  }
}

// 옛 라우트 리다이렉트(App.js: /maintancetmng -> /projectmng?type=maint)에서 넘어오는
// ?type=project|maint|all 값을 백엔드 PRJ_TYP 코드로 바꾼다. 인식 못 하는 값(없음/오타 등)은
// null을 돌려줘서 "쿼리로 지정한 게 없다" = 저장된 값/기본값을 그대로 쓰게 한다.
export function mapQueryTypeToContractType(queryType) {
  if (queryType === 'project') return CONTRACT_TYPE_PROJECT;
  if (queryType === 'maint') return CONTRACT_TYPE_MAINT;
  if (queryType === 'all') return CONTRACT_TYPE_ALL;
  return null;
}

// 행(row)의 PRJ_TYP에 맞는 상세화면 베이스 경로. 목록만 합쳤고 상세/스텝 라우트는
// 그대로 뒀으므로, 유지보수 행을 클릭하면 계속 /maintancetmng 상세로 보내야 한다.
export function resolveContractDetailBasePath(prjTyp) {
  return prjTyp === CONTRACT_TYPE_MAINT ? '/maintancetmng' : '/projectmng';
}
